import {
    SOCIETY_GET_ATTENDANCE_REPORT,
    SOCIETY_GET_MY_ATTENDANCE_STATUS,
    SOCIETY_PUNCH_ATTENDANCE,
    SOCIETY_GET_MY_ATTENDANCE_PUNCHES,
    SOCIETY_GET_MY_ATTENDANCE_SUMMARY,
    SOCIETY_GET_ATTENDANCE_ENUMS,
    SOCIETY_UPDATE_ATTENDANCE_PUNCH,
    SOCIETY_GET_ADMIN_ATTENDANCE_DAILY,
    SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY,
    SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES,
    SOCIETY_CREATE_MANUAL_PUNCH,
    SOCIETY_APPROVE_ATTENDANCE_PUNCH,
    SOCIETY_REJECT_ATTENDANCE_PUNCH,
} from '../../index.types';

export function getAttendanceReport(data) {
    return {
        type: SOCIETY_GET_ATTENDANCE_REPORT,
        data,
    };
}

// data: { latitude?, longitude? } — pass fresh coords so the response carries
// live geofence distance for the punch screen.
export function getMyAttendanceStatus(data) {
    return {
        type: SOCIETY_GET_MY_ATTENDANCE_STATUS,
        data,
    };
}

// data: punch payload (client_request_id, coords, selfie?, …) plus optional
// onSuccess(result) / onError({ code, message, data }) callbacks — the saga
// invokes them so the punch screen can branch on the machine-readable code.
export function punchAttendance(data) {
    return {
        type: SOCIETY_PUNCH_ATTENDANCE,
        data,
    };
}

export function getMyAttendancePunches(data) {
    return {
        type: SOCIETY_GET_MY_ATTENDANCE_PUNCHES,
        data,
    };
}

export function getMyAttendanceSummary(data) {
    return {
        type: SOCIETY_GET_MY_ATTENDANCE_SUMMARY,
        data,
    };
}

export function getAttendanceEnums(data) {
    return {
        type: SOCIETY_GET_ATTENDANCE_ENUMS,
        data,
    };
}

// Admin punch correction (attendance.manage).
// data: { punch_id, update_reason (required), punch_type?, punch_at?, notes?,
// onSuccess?, onError? }. onSuccess receives { punch, attendance, previous_day } —
// refresh the edited row from `attendance`, and ALSO the `previous_day` rollup
// when non-null (the time change moved the punch across an attendance-day
// boundary). Editing a PENDING_APPROVAL punch keeps it pending.
export function updateAttendancePunch(data) {
    return {
        type: SOCIETY_UPDATE_ATTENDANCE_PUNCH,
        data,
    };
}

// ---- Admin attendance management (permission-gated) -----------------------

// data: daily-grid filters (search, department, from, to, day_status, …)
export function getAdminAttendanceDaily(data) {
    return {
        type: SOCIETY_GET_ADMIN_ATTENDANCE_DAILY,
        data,
    };
}

// data: { date? } — defaults to today in the society's attendance day
export function getAdminAttendanceSummary(data) {
    return {
        type: SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY,
        data,
    };
}

// data: punch-grid filters (employee_id, from, to, status, punch_type, …)
export function getAdminAttendancePunches(data) {
    return {
        type: SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES,
        data,
    };
}

// data: { employee_id, punch_type, punch_at, manual_reason, notes?, onSuccess?, onError? }
export function createManualPunch(data) {
    return {
        type: SOCIETY_CREATE_MANUAL_PUNCH,
        data,
    };
}

// data: { punch_id, notes?, onSuccess?, onError? } — approving clears the
// review flag only; the time was already counted, totals don't change.
export function approveAttendancePunch(data) {
    return {
        type: SOCIETY_APPROVE_ATTENDANCE_PUNCH,
        data,
    };
}

// data: { punch_id, notes (required), onSuccess?, onError? } — rejection
// removes the punch's time; refresh the day row from the returned attendance.
export function rejectAttendancePunch(data) {
    return {
        type: SOCIETY_REJECT_ATTENDANCE_PUNCH,
        data,
    };
}
